import { Grid } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import './Tonnage.scss';
import TonnageSearch from './TonnageSearch';
import TonnageInput from './TonnageInput';
import TonnageTable from './TonnageTable';
import { useDispatch, useSelector } from 'react-redux';
import { setTriggerRefreshInput, setTriggerSave } from './reducers/TonnageInputReducer';
import { resetTonnageSearch, setTriggerFocusTonnageName, setTriggerTonnageSearch } from './reducers/TonnageSearchReducer';
import { quickInputSelector } from '../QuickInput/reducers/QuickInputReducer';

let triggerHotkeyAlready = false;

const Tonnage: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const quickInputData = useSelector(quickInputSelector);

    useEffect(() => {
        document.title = "Tonnage";

        // attach the event listener
        document.addEventListener('keydown', handleKeyPress);
    }, []);

    const handleKeyPress = useCallback((event: KeyboardEvent) => {
        if (!triggerHotkeyAlready) {

            if (event.altKey) {
                switch (event.key) {
                    case "s":
                        //save
                        dispatch(setTriggerSave((new Date()).getTime()));
                        triggerHotkeyAlready = true;
                        break;
                    case "r":
                        //refresh save
                        dispatch(setTriggerRefreshInput((new Date()).getTime()));
                        break;
                    case "w":
                        //search
                        dispatch(setTriggerTonnageSearch((new Date()).getTime()));
                        triggerHotkeyAlready = true;
                        break;
                    case "q":
                        //refresh search
                        dispatch(resetTonnageSearch());
                        dispatch(setTriggerFocusTonnageName(new Date().getTime()));
                        break;
                    default:
                        break;
                }
            }

            setTimeout(() => {
                triggerHotkeyAlready = false;
            }, 2000);
        }
    }, []);

    return (
        <Grid container className="tonnage">
            <Grid item lg={2} xs={12} className="left-search-area">
                <TonnageSearch></TonnageSearch>
            </Grid>
            <Grid item lg={10} xs={12} className="right-content">
                <Grid container className="input-fields">
                    <div className={quickInputData.showQuickInput ? "tonnage-quick-input-collapse" : "tonnage-quick-input-expand"}>
                        <TonnageInput></TonnageInput>
                    </div>
                </Grid>
                <Grid container className="datatable">
                    <TonnageTable>
                    </TonnageTable>
                </Grid>
            </Grid>
        </Grid>
    )
};

export default Tonnage;